<template>
  <div class="error-page-wrapper">
    <div class="content">
      <img
        v-if="mainImage === 'no-page'"
        src="@/assets/no-page.png"
        alt="error-image"
        class="img-responsive"
      />
      <img
        v-else
        src="@/assets/access-denied.svg"
        alt="error-image"
        class="img-responsive"
      />
      <h1 class="my-4">{{ pageTitle }}</h1>
      <p>{{ pageDescription }}</p>
      <p>
        If you think this is a mistake, or need to regain access,<br />
        please <strong>contact your HR admin</strong> for assistance.
      </p>
      <router-link :to="homePath" role="link">
        <img
          class="mt-5"
          src="@/assets/sprout-logo-2020.svg"
          alt="sprout-logo"
        />
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.error-page-wrapper {
  height: 100vh;
  display: grid;
  place-items: center;
  position: relative;
  z-index: 1;
  text-align: center;
  color: #3c5b51;
}
.error-page-wrapper::before,
.error-page-wrapper::after {
  content: '';
  position: absolute;
  width: 416px;
  height: 414px;
  bottom: 0;
}

.error-page-wrapper::before {
  background: url('../../src/assets/cloud.svg') no-repeat bottom center;
  left: 0;
}

.error-page-wrapper::after {
  background: url('../../src/assets/cloud.svg') no-repeat bottom center;
  right: 0;
  transform: rotateY(180deg);
}

.error-page-wrapper ~ a {
  z-index: 1;
}

.error-page-wrapper h1 {
  font-size: 1.5em;
  font-weight: 500;
  line-height: 1.75em;
}

body.-with-nav .error-page-wrapper {
  width: 100vw;
  height: 100vh;
  display: grid;
  place-content: center;
}

/* IE Fallbacks */
@media all and (forced-colors: none), (forced-colors: active) {
  .error-page-wrapper {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
  }

  body.error-page > a {
    position: absolute;
    left: 50%;
    bottom: 10%;
    transform: translate(-50%, -50%);
  }
}
</style>
<style>
.error-page #app {
  grid-template-rows: auto;
}
</style>

<script>
import { onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

export default {
  props: {
    pageTitle: { default: 'Error', type: String },
    pageDescription: { default: '', type: String },
    mainImage: { default: '', type: String },
    withNav: { default: false, type: Boolean },
  },
  setup(props) {
    const route = useRoute();

    const homePath =
      route.name != 'access-denied'
        ? { name: 'home' }
        : { name: 'route-to-v1', query: { redirectTo: 'login' } };

    onMounted(() => {
      document.body.classList.add('error-page');
      if (props.withNav) {
        document.body.classList.add('-with-nav');
      }
    });

    onUnmounted(() => {
      document.body.classList.remove('error-page');
      document.body.classList.remove('-with-nav');
    });

    return {
      homePath,
    };
  },
};
</script>
